import React, { Component } from 'react'
import { OperationStart } from 'stylewhere/components'
import { SimpleItemListExtensions } from 'stylewhere/extensions'

export default class SimpleItemListStart extends Component {
  render() {
    return <OperationStart submitPath="/simple-item-list/:opCode/reading" extensions={SimpleItemListExtensions} />
  }
}
